import { colours } from "@affinity/constants/StyleConstants";
import React from "react";
import styled, { keyframes } from "styled-components";

const SkeletonAnimation = keyframes`
  0% {
    background-position: -300px 0;
  }
  100% {
    background-position: calc(300px + 100%) 0;
  }
`;

const AnimatedText = styled.span`
    display: inline-block;
    background-color: ${colours.darkBlue}33;
    color: transparent;
    user-select: none;
    background-image: linear-gradient(100deg, transparent 0px, ${colours.darkBlue}33 40px, transparent 80px);
    background-size: 200px 100%;
    border-radius: 4px;
    height: 1.2em;
    margin-top: 0.2em;
    animation: ${SkeletonAnimation} 2.5s ease-in-out infinite;
`;

export const SkeletonText: React.FC<{ isLoading?: Boolean }> = ({ isLoading, children }) => {
    if (isLoading) {
        return <AnimatedText>{children}</AnimatedText>;
    }

    return <>{children}</>;
};
